import React, { FunctionComponent } from 'react';
import { Pill } from 'components/Pill';
import { LiveNowPill } from 'components/LiveNowPill';

interface CardStatusesProps {
  isLive?: boolean;
  isPrivate?: boolean;
  isPlaying?: boolean;
  isFallback?: boolean;
  duration?: string;
  type: 'event' | 'recording';
}

export const CardStatuses: FunctionComponent<CardStatusesProps> = ({
  isLive,
  isPrivate,
  isPlaying,
  isFallback,
  duration,
  type
}) => {
  return (
    <div className="tw-inline-flex tw-gap-4">
      {type === 'event' && isLive && (
        <LiveNowPill isLive={isLive} isFallback={isFallback} />
      )}
      {type === 'event' && !isLive && (
        <Pill label={'Upcoming'} type={'default'} icon={'calendar'} />
      )}
      {type === 'recording' && (
        <Pill
          label={duration}
          type={'default'}
          icon={isPlaying ? 'stop' : 'play'}
        />
      )}
      {isPrivate && <Pill label={'Private'} type={'default'} icon={'lock'} />}
    </div>
  );
};
